import { Component, inject, DestroyRef, effect } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { APP_CONST } from 'src/app/shared/constants/app-constants';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { ManagersService } from 'src/app/shared/services/managers/managers.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { FormsModule } from '@angular/forms';
import { NgIf, NgClass, NgStyle, NgFor } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';

@Component({
  selector: 'app-account-home',
  templateUrl: './account-home.component.html',
  styleUrls: ['./account-home.component.scss'],
  imports: [
    FormsModule,
    NgIf,
    NgClass,
    NgStyle,
    NgFor,
    LtmsLoaderComponent,
  ]
})
export class AccountHomeComponent {
  searchQuery: string = '';
  accountsDetails: any;
  accountId!: string;
  recentVisitList: any[] = [];
  recentVisitListLocalStorage: any[] = [];
  totalProjects = 0;
  isExistsRecentVisitProject = false;
  currentLoggedInManagerDetails = {};
  showLoader = true;
  isDataAvailable = false;
  destroyRef = inject(DestroyRef);
  sortingOrder = {
    recentProjects: 'asc',
    projectList: 'asc',
  };
  projectType: any;
  userId: string = '';
  private projectTypeSubscription: any;
  buttons = [
    {
      title: 'Scores',
      description:
        'Response Analytics Summary along with trends of Overall score and customer responses across different interactions.',
      action: 'scores',
      class: 'quick_access-card',
      icon: 'assets/images/quick-access-score.svg',
    },
    {
      title: 'Inbox',
      description:
        'Unlock valuable insights from customer responses across projects, powered by advanced Text Analytics.',
      action: 'inbox',
      class: 'quick_access-card2',
      icon: 'assets/images/quick-access-inbox.svg',
    },
    {
      title: 'Engagement',
      description:
        'Request Analytics with key engagement insights like the Response Rate, Requests Trends, and much more. ',
      action: 'engagement',
      class: 'quick_access-card3',
      icon: 'assets/images/quick-access-engagement.svg',
    },
  ];
  insightsCard: any = {
    title: 'Online Reputation Management',
    description:
      'AI-powered insights and social listening, so you never miss what customers are saying.',
    action: 'insights',
    class: 'quick_access-card4',
    icon: 'assets/images/insights.png',
  };
  isAccountManager: boolean = false;
  brandIdsList: string[] = [];

  constructor(
    private HelpersService: HelpersService,
    private _managersService: ManagersService,
    private route: ActivatedRoute,
    private router: Router,
    private headerService: HeaderService,
    private appStateService: AppStateService
  ) {
    effect(() => {
      if (this.appStateService.initialized()) {
        const acountDetails:any = this.appStateService.accountDetails()
        if(acountDetails && !_.isEmpty(acountDetails)){
          this.accountId = acountDetails._id;
          const mainMenu = this.HelpersService.getActiveSideMenu(true, this.accountId);
          const quickAccessButtons:any = {
            "scores": this.HelpersService.isTabVisible(true, 'scores'),
            "inbox": this.HelpersService.isTabVisible(true, 'inbox'),
            "engagement": this.HelpersService.isTabVisible(true, 'engagement')
          };
          this.buttons = _.filter(this.buttons, (button: any) => {
            return quickAccessButtons[button.action];
          });
        }
      }
    });
  }

  baseFilter = (ele: any) => (ele?.is_single_touchpoint_setup && ele?.project_info?.project_status && [1, 2, 3, 6].indexOf(parseInt(ele?.project_info?.project_status)) != -1 && _.get(ele, 'show_on_dashboard') != false);
  
  getClassNameBySorting(table: string): string {
    const baseClass = 'fw-bold projects_color';
    const isDescending = this.sortingOrder[table] === 'desc';
    return isDescending ? `${baseClass} blue` : baseClass;
  }

  ngOnInit() {
    const managerDetails = _.get(Helpers, 'managerDetails.manager', {});
    this.userId = managerDetails._id;
    this.accountId = _.get(Helpers, 'accountDetails._id', {});
    this.isAccountManager = false;
    this.brandIdsList = [];
    // user this code to filter revoked access of project if user is not account manager
    if (managerDetails.manager_access && !_.isEmpty(managerDetails.manager_access)) {
      _.forEach(managerDetails.manager_access, (access: any) => {
        if (access.account_id === this.accountId) {
          if (access.manager_type == 2 && access.has_dashboard_access) {
            this.brandIdsList.push(access.brand_id);
          } else if (access.manager_type == 3 && access.has_dashboard_access) {
            this.isAccountManager = true;
          }
        }
      });
    }
    if (localStorage.getItem('RVLIST')) {
      const RVList = JSON.parse(
        localStorage.getItem('RVLIST') || '{}'
      );
      if (Array.isArray(RVList)) {
        localStorage.removeItem('RVLIST')
      }
      const recentVisitData = RVList;
      const account_id = this.accountId;
      const key = `${account_id}-${this.userId}`;

      let visitList = recentVisitData[key] || [];
      if (visitList && visitList.length > 0) {
        visitList = visitList.filter((ele: any) => {
          return this.isAccountManager ? true : this.brandIdsList.includes(ele.project_id);
        });
      }

      this.recentVisitListLocalStorage = _.orderBy(
        visitList,
        ['last_visited'],
        ['desc']
      );
      this.isExistsRecentVisitProject =
        this.recentVisitListLocalStorage.length > 0;
    } else {
      this.isExistsRecentVisitProject = false;
    }

    const isInsightsEnabled = _.get(
      Helpers.accountDetails,
      'third_party_integration.social_listening.enabled',
      false
    );
    if (isInsightsEnabled) {
      const config: any = _.get(
        Helpers.accountDetails,
        'third_party_integration.social_listening',
        {}
      );
      if (config.title) {
        this.insightsCard.title = config.title;
      }

      if (config.description) {
        this.insightsCard.description = config.description;
      }

      this.buttons.push(this.insightsCard);
    } else {
      this.buttons = _.filter(this.buttons, (button: any) => {
        return button.action != 'insights';
      });
    }

    this.route.queryParams.subscribe((params) => {
      this.accountId = params['account_id'];
      this.getAccountDetail(this.accountId);
      this.headerService.toggleSignedInAsButtonVisibility(false);

      this.projectTypeSubscription = this.HelpersService.projectType.subscribe(
        (updatedValue) => {
          this.projectType = updatedValue;
          this.filterProjectsByType();
          this.filterRecentVisitProjectsByType();
        }
      );
    });
  }

  ngOnDestroy() {
    this.headerService.toggleSignedInAsButtonVisibility(true);
    if (this.projectTypeSubscription) {
      this.projectTypeSubscription.unsubscribe();
    }
  }

  visibleBrandIdsList: string[] = [];
  // get Account details by Account id
  getAccountDetail(accountID) {
    // this.AccountsService.getBrandsList(accountID).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
    //   (response) => {
    // No need to call API to get the details.
    this.accountsDetails = Helpers.brandListDetail.filter(this.baseFilter);
    this.totalProjects = this.accountsDetails.length; 
    if (!this.totalProjects) {
      //No Projects Available
      this.router.navigate(['message'], {
        queryParams: {
          status: '401',
        },
      });
    } else {
      this.accountsDetails = _.orderBy(this.accountsDetails, ['name'], ['asc']); // Apply sorting by default in ascending order
      // if (this.accountsDetails.length === 1) {
      //   this.navigateTo(this.accountId, this.accountsDetails[0]['_id'], this.accountsDetails[0].name)
      // }
      // filter brand list for recent visit ...
      // console.log("LLLLLLLLLLLLLLLLLLLLLLLLl")
      this.visibleBrandIdsList = _.map(this.accountsDetails,(value)=>value._id)
      let finalBrandList: any = [];

      finalBrandList = _.filter(this.recentVisitListLocalStorage, (value: any) => {
        return value.project_id && this.visibleBrandIdsList.includes(value.project_id);
      });
      if (finalBrandList.length > 0) {
        this.recentVisitList = finalBrandList;
        this.isExistsRecentVisitProject = true;
      } else {
        this.recentVisitList = [];
        this.isExistsRecentVisitProject = false;
      }
      // update recent visit list in local storage only when there is a change in the recent visit list
      if(finalBrandList && finalBrandList.length  !== this.recentVisitListLocalStorage.length){
        const key = `${this.accountId}-${this.userId}`;
        const recentVisit = JSON.parse(localStorage.getItem('RVLIST') || '{}');
        if(recentVisit[key] && recentVisit[key].length > 0){
          recentVisit[key] = finalBrandList;
          localStorage.setItem('RVLIST', JSON.stringify(recentVisit));
        }
      }
      this.isDataAvailable = true;
      // },
      // (error) => {
      //   console.error('Error during account details API call:', error);
      // })
    }
  }

  // Method to filter projects based on the selected project type
  filterProjectsByType(): void {
    // Default filter condition for projects with `is_single_touchpoint_setup` set to true
    

    // If projectType is not set or is invalid, show all projects with the base filter condition
    if (!this.projectType?.project_type) {
      this.accountsDetails = Helpers.brandListDetail.filter(this.baseFilter);
    } else {
      // Filter by project_type and base condition
      this.accountsDetails = Helpers.brandListDetail.filter(
        (ele: any) =>
          ele?.project_type === this.projectType.project_type && this.baseFilter(ele)
      );
    }
    this.totalProjects = this.accountsDetails.length;
    this.accountsDetails = _.orderBy(this.accountsDetails, ['name'], ['asc']);
  }

  // Method to filter recent visit projects based on the selected project type
  filterRecentVisitProjectsByType(): void {
    const baseCondition = (ele: any) =>
      ele?.is_single_touchpoint_setup &&
      ele.account_id === this.accountId &&
      ele.userId === this.userId && ele.project_id && this.visibleBrandIdsList.includes(ele.project_id) && (this.isAccountManager ? true : this.brandIdsList.includes(ele.project_id));

    if (!this.projectType?.project_type) {
      // If project type is not set, filter by the base condition only
      this.recentVisitList =
        this.recentVisitListLocalStorage.filter(baseCondition);
      this.showLoader = false;
    } else {
      // Filter by project_type and the base condition
      this.recentVisitList = this.recentVisitListLocalStorage.filter(
        (ele: any) =>
          baseCondition(ele) &&
          ele.project_type === this.projectType.project_type
      );
      this.showLoader = false;
    }
  }

  sortList(
    listKey: 'projectList' | 'recentProjects',
    sortBy: 'name' | 'last_visited'
  ): void {
    if (!this.sortingOrder[listKey]) {
      this.sortingOrder[listKey] = 'desc';
    } else {
      this.sortingOrder[listKey] =
        this.sortingOrder[listKey] === 'asc' ? 'desc' : 'asc';
    }

    const currentOrder: any = this.sortingOrder[listKey];

    if (listKey === 'projectList') {
      this.accountsDetails = _.orderBy(
        this.accountsDetails,
        [sortBy],
        [currentOrder]
      );
    } else if (listKey === 'recentProjects') {
      this.recentVisitList = _.orderBy(
        this.recentVisitList,
        [sortBy],
        [currentOrder]
      );
    }
  }
  navigateTo(
    accounts_id: string,
    projectId: string,
    { name, project_type, is_single_touchpoint_setup, ...data }
  ) {
    this.setCursor('wait', projectId);
    this._managersService
      .setCurrentLoggedInManager(accounts_id, projectId)
      .subscribe((reponse: any) => {
        if (
          this.HelpersService.helpers['managerDetails']['last_synced_details']
        ) {
          delete this.HelpersService.helpers['managerDetails'][
            'last_synced_details'
          ];
          window['Helpers'] = this.HelpersService.consoleData();
        }
        this.setCursor('default', projectId);
        this.router.navigate([APP_CONST.ROUTE_PROJECT_DETAILS], {
          queryParams: {
            account_id: accounts_id,
            project_id: projectId,
          },
        });
      });
  }

  setCursor(cursorStyle: string, projectId: string): void {
    // You can apply the cursor style to the entire body or specific elements
    try {
      // document.body.style.cursor = cursorStyle;
      let selectedBrand = document.getElementById(
        'brandlistselection_' + projectId
      );
      if (selectedBrand) {
        selectedBrand.style.cursor = cursorStyle;
      }
    } catch (error) {
      console.log('Error while setting up cursor, Error: ', error);
    }
  }

  jumpTo(accounts_id: string, tab_name: string) {
    if (tab_name == 'insights') {
      window.open('https://www.centra360.litmusworld.com/', '_blank');
    } else {
      this.router.navigate(['/accounts/' + tab_name], {
        queryParams: {
          account_id: accounts_id,
        },
      });
    }
  }

  filteredProjects() {
    if (!this.accountsDetails) {
      return [];
    }
    if (!this.searchQuery) {
      return this.accountsDetails;
    }
    return this.accountsDetails.filter((project: any) =>
      project.name.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
  }

  // Method to update search query and trigger filtering
  onSearchChange(query: string) {
    this.searchQuery = query;
  }

  clearSearch() {
    this.searchQuery = '';
  }
}
